export default __webpack_public_path__ + "static/TriDymeIcon-4cf79b86a82b1d201f6283135dfb1a78.png";